import React, { useCallback, useContext, useMemo, useState, } from 'react';
import { connect, } from 'react-redux';
import Box from '@material-ui/core/Box';

import Icon from 'common/components/Icon';
import TextField from 'common/components/TextField';
import Button from 'common/components/Button';
import { components, pages, } from 'styles';
import { Product, } from './types';
import { NotificationStateContext, } from 'common/components/NotificationProvider';
import { repositories, } from 'api';
import { PendingData, } from 'store/ducks/pendingData/types';
import { getIsLoadingFlagAtAddingItemsToTheCartShop, } from 'common/selectors';

type Props = Omit<Product, 'availability'> & {
    addToShopCart: Function,
    images: repositories.products.CollectionTypes.ProductsImageType,
    pendingData: {
        carts: boolean,
        cartItems: boolean,
    },
};

const notificationBaseConfig = {
    open: true,
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    },
};

const notificationConfig = {
    success: {
        ...notificationBaseConfig,
        text: 'Produkt został dodany do koszyka',
    },

    error: {
        ...notificationBaseConfig,
        severity: 'error',
    }
};

const ProductsItemOrderPanelActions: React.FC<Props> = ({
    addToShopCart,
    name,
    code,
    slug,
    price,
    type,
    images,
    pendingData,
    minQuantity,
    taxAmount,
}) => {
    const notification = useContext(NotificationStateContext);
    const iconWrapperClasses = components.makeIconWrapperStyles();
    const inputQuantityClasses = components.makeQuantityInputStyles();
    const buttonClasses = pages.products.makeProductsItemButtonStyles();

    const [ quantity, setQuantity, ] = useState(1);
    const hasError = useMemo(() => quantity <= 0, [ quantity, ]);

    const onChangeSetQuantity = useCallback(
        event => setQuantity(Number(event.target.value)),
        [ setQuantity, ]
    );

    const invokeAddToShopCart = useCallback(
        () => {
            const showNotification = (data?: { error?: boolean, messages?: Array<string> }) => {
                const config = data?.error ? 'error' : 'success';

                const finalConfig = data?.error
                                    ? { ...notificationConfig[config], text: data?.messages || 'Błąd zamówienia', }
                                    : notificationConfig[config];

                // @ts-ignore
                notification.setConfig(finalConfig);
            };

            const product = {
                name,
                code,
                slug,
                price,
                type,
                images,
                minQuantity,
                taxAmount,
            };

            addToShopCart(product, quantity, showNotification);
        },
        [
            name,
            code,
            slug,
            price,
            type,
            images,
            notification,
            addToShopCart,
            quantity,
            minQuantity,
            taxAmount,
        ]
    );

    return (
        <>
            <TextField InputLabelProps={{ shrink: true, }}
                       inputProps={{ className: inputQuantityClasses.root, min: 1, }}
                       label="egz."
                       type="number"
                       error={hasError}
                       defaultValue={quantity}
                       onChange={onChangeSetQuantity}
                       variant="outlined" />
            <Button size="small"
                    className={buttonClasses.root}
                    onClick={invokeAddToShopCart}
                    disabled={hasError || pendingData.cartItems || pendingData.carts}>
                <Box className={iconWrapperClasses.root}>
                    <Icon.Cart height={20} />
                </Box>
                Dodaj do koszyka
            </Button>
        </>
    );
};

type MappingType = {
    pendingData: PendingData,
};

const mapStateToProps = ({ pendingData, }: MappingType) => ({
    pendingData: getIsLoadingFlagAtAddingItemsToTheCartShop(pendingData),
});

export default connect(
    mapStateToProps,
)(ProductsItemOrderPanelActions);
